import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const m = (v) => `$${Number(v || 0).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const dt = (s) => (s ? new Date(s).toLocaleString('es-MX', { dateStyle: 'medium', timeStyle: 'short' }) : '—');

export const CutsInRangeDialog = ({ open, onClose, qs }) => {
  const [d, setD] = useState(null);
  useEffect(() => {
    if (!open) return;
    setD(null);
    axios.get(`${API}/reports/cuts-in-range?${qs}`, { withCredentials: true })
      .then(r => setD(r.data)).catch(e => toast.error(e.response?.data?.detail || 'Error al cargar cortes'));
  }, [open, qs]);

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-5xl max-h-[90vh] overflow-y-auto" data-testid="cuts-in-range-dialog">
        <DialogHeader><DialogTitle>🧾 Cortes incluidos en el periodo</DialogTitle></DialogHeader>
        {!d ? <p className="text-sm text-muted-foreground py-8 text-center">Cargando…</p> : d.cuts.length === 0 ? (
          <p className="text-sm text-center text-slate-500 py-6">No hay cortes en este periodo</p>
        ) : (
          <table className="w-full text-sm border rounded" data-testid="cuts-in-range-table">
            <thead className="bg-slate-50 text-[11px] uppercase text-slate-500"><tr>
              <th className="px-3 py-2 text-left">Corte</th><th className="px-3 py-2 text-left">Apertura</th><th className="px-3 py-2 text-left">Cierre</th>
              <th className="px-3 py-2 text-right"># Ventas</th><th className="px-3 py-2 text-right">Venta total</th><th className="px-3 py-2 text-right">Efectivo</th>
              <th className="px-3 py-2 text-right">Tarjeta</th><th className="px-3 py-2 text-right">Transferencia</th></tr></thead>
            <tbody className="divide-y">
              {d.cuts.map(c => (
                <tr key={c.id} data-testid={`cut-range-row-${c.id}`}>
                  <td className="px-3 py-2 font-medium">{c.folio || c.id.slice(-6)}{c.status !== 'closed' && <span className="ml-1 text-[10px] bg-amber-100 text-amber-700 rounded px-1">Abierto</span>}</td>
                  <td className="px-3 py-2">{dt(c.started_at)}</td><td className="px-3 py-2">{dt(c.closed_at)}</td>
                  <td className="px-3 py-2 text-right">{c.sales_count}</td><td className="px-3 py-2 text-right font-bold">{m(c.sales_total)}</td>
                  <td className="px-3 py-2 text-right">{m(c.cash_total)}</td><td className="px-3 py-2 text-right">{m(c.card_total)}</td>
                  <td className="px-3 py-2 text-right font-semibold text-sky-700">{m(c.transfer_total)}</td>
                </tr>
              ))}
            </tbody>
            <tfoot className="bg-slate-50 font-bold" data-testid="cuts-in-range-totals"><tr>
              <td className="px-3 py-2" colSpan={3}>Total ({d.cuts.length} cortes)</td>
              <td className="px-3 py-2 text-right">{d.totals.sales_count}</td><td className="px-3 py-2 text-right">{m(d.totals.sales_total)}</td>
              <td className="px-3 py-2 text-right">{m(d.totals.cash_total)}</td><td className="px-3 py-2 text-right">{m(d.totals.card_total)}</td>
              <td className="px-3 py-2 text-right text-sky-700">{m(d.totals.transfer_total)}</td>
            </tr></tfoot>
          </table>
        )}
        <p className="text-[11px] text-slate-500">Se incluye cada corte que se cruce con el periodo elegido arriba. Los montos son del corte completo.</p>
      </DialogContent>
    </Dialog>
  );
};
